export default __webpack_public_path__ + "static/media/card_bg_3.54aae268.png";